import ImagesLoaded from "imagesloaded";

ImagesLoaded.makeJQueryPlugin( $ );

export default {
    sortOnKey( array, key ){
        if( !array ) return array;
        array.sort( function( a, b ){
            if( a[ key ] > b[ key ] ){
                return 1;
            }
            if( a[ key ] < b[ key ] ){
                return -1;
            }

            return 0;
        } );
    },

    fakeLocation( url ){
        let fake = document.createElement( 'a' );
        fake.href = url;

        return fake;
    },

    imagesLoaded( ...args ){
        return ImagesLoaded( ...args );
    },

    raf( callback, fallback_delay = 0 ){
        return window.requestAnimationFrame ? window.requestAnimationFrame( callback ) : setTimeout( callback, fallback_delay );
    },

    clearRaf( id ){
        return window.cancelAnimationFrame ? window.cancelAnimationFrame( id ) : clearTimeout( id );
    },

    debounce( fn, delay ){
        let timer = null;
        return function(){
            let context = this, args = arguments;
            clearTimeout( timer );
            timer = setTimeout( function(){
                fn.apply( context, args );
            }, delay );
        };
    },

    throttle( fn, threshhold, scope ){
        threshhold || (
            threshhold = 250
        );
        let last,
            deferTimer;
        return function(){
            let context = scope || this;

            let now = +new Date,
                args = arguments;
            if( last && now < last + threshhold ){
                // hold on to it
                clearTimeout( deferTimer );
                deferTimer = setTimeout( function(){
                    last = now;
                    fn.apply( context, args );
                }, threshhold );
            }else{
                last = now;
                fn.apply( context, args );
            }
        };
    },

    post( path, params, method ){
        method = method || "post"; // Set method to post by default if not specified.

        // The rest of this code assumes you are not using a library.
        // It can be made less wordy if you use one.
        let form = document.createElement( "form" );
        form.setAttribute( "method", method );
        form.setAttribute( "action", path );

        for( let key in params ){
            if( params.hasOwnProperty( key ) ){
                let hiddenField = document.createElement( "input" );
                hiddenField.setAttribute( "type", "hidden" );
                hiddenField.setAttribute( "name", key );
                hiddenField.setAttribute( "value", params[ key ] );

                form.appendChild( hiddenField );
            }
        }

        document.body.appendChild( form );
        form.submit();
    },

    numberFormat( price, decimals = 0, decimal_sep = '.', thousand_sep = ' ' ){
        decimals = isNaN( decimals = Math.abs( decimals ) ) ? 2 : decimals;
        let negative = price < 0 ? "-" : "";

        price = Math.abs( Number( price ) || 0 )

        let abs_price_str = parseInt( price ).toFixed( decimal_sep ),
            thousand_remaining = abs_price_str.length > 3 ? abs_price_str.length % 3 : 0;

        return negative
            + ( thousand_remaining ? abs_price_str.substr( 0, thousand_remaining ) + thousand_sep : "" )
            + abs_price_str.substr( thousand_remaining ).replace( /(\d{3})(?=\d)/g, "$1" + thousand_sep )
            + ( decimal_sep && decimals ? decimal_sep + Math.abs( price - abs_price_str ).toFixed( decimals ).slice( 2 ) : "" );
    },

}



// WEBPACK FOOTER //
// ./resources/assets/js/framework/Utils.js